import React, {Component} from "react";
import UsageLineChart from "../../../common/graph/line-chart.compnent";
import "../personal/monthly-trend.component.css";
class MonthlyTrend extends Component {
    render() {       
        return ( 
           <div className="usage-spend-wrapper usage-line-main-container">
                <UsageLineChart invoiceMonth={this.props.invoiceMonth} circuitId={this.props.circuitId} financeAccountId={this.props.financeAccountId} chartWidth={this.props.chartWidth} data={this.props.usageSpendLineDataSix} ledger={this.props.ledger} setRef={this.props.setRef} usageSpendBarData={this.props.usageSpendBarData} />
           </div>
        )
    }
}

export default MonthlyTrend
